import moment from 'moment';

export const dateFormatter = (date: Date | string, type: 'long' | 'short' = 'long') => {
	const intlDateFormatter = Intl.DateTimeFormat('en-US', {
		month: type,
		year: 'numeric',
	});

	const dateStr = moment(date, 'MMM YYYY').toString();
	const normalizedDate = !(date instanceof Date) ? new Date(dateStr) : date;
	return intlDateFormatter.format(normalizedDate);
};
